'use strict';

angular.module('internal.vehicles', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // vehicles tab            
            .state('internal.licensing.vehicle', {
                abstract: true,
                templateUrl: paths.app + 'vehicles/components/vehicle/vehicle.html',
                controller: 'InternalVehicle',
                params: {
                    id: null,
                    vehicle: null
                }
            })
            .state('internal.licensing.vehicle.investigations', {
                url: '/vehicle/:id/investigations',
                templateUrl: paths.app + 'vehicles/components/vehicle-investigations/vehicle-investigations.html',
                controller: 'InternalVehicleInvestigations',
                params: {
                    id: null,
                    vehicle: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.vehicle.locationsList', {
                url: '/vehicles/transportation/:id/locations',
                templateUrl: paths.app + 'vehicles/components/vehicle-react/vehicle-react.html',
                controller: 'InternalVehicleReact',
                params: {
                    id: null,
                    vehicle: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.vehicle.history', {
                url: '/vehicle/:id/history',
                templateUrl: paths.app + 'vehicles/components/vehicle-history/vehicle-history.html',
                controller: 'InternalVehicleHistory',
                params: {
                    id: null,
                    vehicle: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
    }])
;